import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import schoolImg from '../../assets/SchoolBuilding.jpg';
import LineSeperator from '../ui/LineSeperator';
import '../../stylings/AboutUs.css';

gsap.registerPlugin(ScrollTrigger);

export default function AboutUs() {
  const imgRef = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(imgRef.current, { opacity: 0, x: -60 }, {
      opacity: 1, x: 0, duration: 0.8, ease: 'power2.out',
      scrollTrigger: { trigger: imgRef.current, start: 'top 80%' },
    });
    gsap.fromTo(textRef.current, { opacity: 0, x: 60 }, {
      opacity: 1, x: 0, duration: 0.8, ease: 'power2.out',
      scrollTrigger: { trigger: textRef.current, start: 'top 80%' },
    });
  }, []);

  return (
    <section className="about-section">
      <div className="container-fluid px-5">
        <LineSeperator title="About Our School" />
        <div className="row align-items-center g-5 mt-2">
          <div className="col-lg-6" ref={imgRef}>
            <div className="about-img-wrapper">
              <img src={schoolImg} alt="Akash Model School Building" className="about-img" />
              <div className="about-img-badge">
                <span className="badge-year">1991</span>
                <span className="badge-text">Est.</span>
              </div>
            </div>
          </div>
          <div className="col-lg-6" ref={textRef}>
            <div className="about-content">
              <span className="about-label">Welcome to</span>
              <h2 className="about-heading">Akash Model Sr. Sec. School</h2>
              <p className="about-tagline">Work Is Worship</p>
              <p className="about-text">
                Akash Model Sr. Sec. School, established in 1991, is a premier CBSE-affiliated institution
                located in Baljeet Vihar, New Delhi. We have been shaping young minds for over three decades,
                providing a nurturing environment that combines academic excellence with holistic development.
              </p>
              <p className="about-text">
                Our institution offers a modern curriculum supported by experienced faculty, state-of-the-art
                infrastructure including AI labs, smart classrooms, and world-class sports facilities. We
                believe in the motto <strong>"Work Is Worship"</strong> — instilling discipline, integrity,
                and a passion for learning in every student.
              </p>
              <div className="about-quick-stats">
                <div className="quick-stat">
                  <span className="qstat-num">34+</span>
                  <span className="qstat-label">Years of Excellence</span>
                </div>
                <div className="quick-stat">
                  <span className="qstat-num">150+</span>
                  <span className="qstat-label">Qualified Staff</span>
                </div>
                <div className="quick-stat">
                  <span className="qstat-num">3000+</span>
                  <span className="qstat-label">Students</span>
                </div>
              </div>
              <Link to="/about-school" className="about-cta-btn">Read More</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
